import React from "react";
import Tilt from "react-parallax-tilt";
import github from "../../Assets/github.png";
import "./projectCard.css";
import LazyLoad from "react-lazyload";

const ProjectCards = ({
  index,
  name,
  description,
  tags,
  image,
  source_code_link,
}) => {
  return (
    <div className="parent">
      <Tilt
        options={{
          max: 15,
          scale: 1,
          speed: 450,
        }}
      >
        <div className="container-project">
          <div className="image-parent">
            <img
              src={image}
              alt="project_image"
              className="image"
              loading="lazy"
            />
          </div>
          {/* github icon start*/}
          <div className="github-parent">
            <LazyLoad
              height={200}
              once
              offset={100}
              placeholder={<div className="placeholder" />}
              blur={10}
            >
              <img
                src={github}
                alt="source code"
                className="github-img"
                onClick={() => window.open(source_code_link, "_blank")}
              />
            </LazyLoad>
          </div>
          {/* github icon end*/}
          <div className="title">{name}</div>
          <div className="description">{description}</div>
          <div className="tag">
            {tags.map((tag, index) => (
              <p
                key={`${name}-${index}`}
                style={{ color: `${tag.color}` }}
                className="tag-p"
              >
                #{tag.name}
              </p>
            ))}
          </div>
        </div>
      </Tilt>
    </div>
  );
};

export default ProjectCards;
